import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@material-ui/core';

import { useStyles } from './PhoneVerificationBanner.styles';
import usePhoneVerificationBanner from './usePhoneVerificationBanner';

function PhoneVerificationBanner() {
    const classes = useStyles();
    const { showBanner, handleVerifyNow } = usePhoneVerificationBanner();

    if (!showBanner) {
        return null;
    }

    return (
        <div className={classes.root}>
            <div className={classes.textSection}>
                <span className={classes.title}>Important Notice:</span>
                <span className={classes.body}>
                    <span className={classes.bodyHighlight}>Enhance your security:</span>
                    {' Verify your phone number to enable SMS authentication.'}
                </span>
            </div>
            <Button
                className={classes.verifyButton}
                variant="contained"
                disableElevation
                onClick={handleVerifyNow}
            >
                Verify Now
            </Button>
        </div>
    );
}

export default observer(PhoneVerificationBanner);
